import { render, staticRenderFns } from "./contentloaders.vue?vue&type=template&id=4a7a8a92&scoped=true&"
import script from "./contentloaders.vue?vue&type=script&lang=js&"
export * from "./contentloaders.vue?vue&type=script&lang=js&"
import style0 from "./contentloaders.vue?vue&type=style&index=0&id=4a7a8a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7a8a92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a7a8a92')) {
      api.createRecord('4a7a8a92', component.options)
    } else {
      api.reload('4a7a8a92', component.options)
    }
    module.hot.accept("./contentloaders.vue?vue&type=template&id=4a7a8a92&scoped=true&", function () {
      api.rerender('4a7a8a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contentloaders.vue"
export default component.exports